/* ==========================================================================
   ZWANZE — media-gallery.js
   Galerie produit. Le defilement est natif ; le JavaScript ne fait que
   synchroniser les pastilles, les miniatures et les fleches. Sans lui, la
   galerie reste utilisable : on fait glisser, et toutes les photos sont
   dans la page.
   ========================================================================== */
(function () {
  'use strict';

  class MediaGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.z-gallery__viewport');
      this.slides = Array.from(this.querySelectorAll('.z-gallery__slide'));
      this.dots = Array.from(this.querySelectorAll('.z-gallery__dot'));
      this.thumbs = Array.from(this.querySelectorAll('.z-gallery__thumb'));
      if (!this.viewport || !this.slides.length) return;

      this.index = 0;
      this.markers = this.dots.concat(this.thumbs);
      this.markers.forEach((marker) => {
        marker.addEventListener('click', () => this.goTo(Number(marker.dataset.go)));
      });

      // Fleches precedent / suivant. Elles ne font rien de plus que ce que
      // faisait deja le glissement du doigt : elles le rendent visible a la
      // souris. Si elles sont absentes du HTML (reglage decoche), tout le
      // reste continue de fonctionner.
      this.prev = this.querySelector('[data-gallery-prev]');
      this.next = this.querySelector('[data-gallery-next]');
      if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index - 1));
      if (this.next) this.next.addEventListener('click', () => this.goTo(this.index + 1));
      this._syncArrows();

      // « Voir les autres photos » : on deplie la colonne, sans rechargement.
      const more = this.querySelector('[data-gallery-more]');
      if (more) {
        more.addEventListener('click', () => {
          this.setAttribute('data-open', '');
          more.setAttribute('hidden', '');
        });
      }

      this.observer = new IntersectionObserver(this._onIntersect.bind(this), {
        root: this.viewport,
        threshold: 0.55
      });
      this.slides.forEach((slide) => this.observer.observe(slide));

      // Au chargement, on se place sur la photo de la variante affichee
      // (voir data-selected dans sections/main-product.liquid). Sans cela,
      // un lien vers le t-shirt kaki ouvrait la page sur la photo du noir.
      const selected = this.querySelector('.z-gallery__slide[data-selected]');
      if (selected && this.slides.indexOf(selected) > 0) {
        this.goTo(this.slides.indexOf(selected), 'auto');
      }
    }

    /* Appelee de l'exterieur (assets/variant-picker.js) quand le visiteur
       change de couleur : la galerie vient sur la photo de cette couleur.
       Renvoie false si cette photo n'existe pas dans la galerie, pour que
       l'appelant sache qu'il ne s'est rien passe. */
    goToMediaId(id) {
      const index = this.slides.findIndex((slide) => slide.dataset.mediaId === String(id));
      if (index < 0) return false;
      // En mode colonne, les photos au-dela des premieres sont repliees :
      // on deplie avant, sinon on ferait defiler vers un element cache.
      if (!this.slides[index].offsetParent) {
        this.setAttribute('data-open', '');
        const more = this.querySelector('[data-gallery-more]');
        if (more) more.setAttribute('hidden', '');
      }
      this.goTo(index);
      return true;
    }

    goTo(i, behavior) {
      const clamped = Math.max(0, Math.min(this.slides.length - 1, i));
      const target = this.slides[clamped];
      if (!target) return;
      // block: 'nearest' est essentiel : la page elle-meme ne bouge pas si la
      // galerie est deja visible, seul le cadre defile lateralement.
      target.scrollIntoView({ behavior: behavior || 'smooth', block: 'nearest', inline: 'center' });
      // On note tout de suite la position visee : l'observateur confirmera,
      // mais deux clics rapides ne doivent pas se marcher dessus.
      this.index = clamped;
      this._syncArrows();
    }

    // Aux extremites, la fleche est desactivee plutot que cachee : une fleche
    // qui disparait decale la photo et fait sursauter la page.
    _syncArrows() {
      if (this.prev) this.prev.disabled = this.index <= 0;
      if (this.next) this.next.disabled = this.index >= this.slides.length - 1;
    }

    _onIntersect(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const index = this.slides.indexOf(entry.target);
        this.index = index;
        this.markers.forEach(function (marker) {
          marker.setAttribute('aria-selected', Number(marker.dataset.go) === index ? 'true' : 'false');
        });
        this._syncArrows();
      });
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }
  if (!customElements.get('z-media-gallery')) customElements.define('z-media-gallery', MediaGallery);
})();
